export enum EApiCallStateNames {
  TICKET_REPORTS = 'TICKET_REPORTS',
  RIDES_REPORTS = 'RIDES_REPORTS',
  VOUCHER_REPORTS = 'VOUCHER_REPORTS',
  RIDE_PASSENGERS_REPORTS = 'RIDE_PASSENGERS_REPORTS',
}

export enum EApiRequestPartKeys {
  SEARCH = 'SEARCH',
  PAGINATION = 'PAGINATION',
  FILTERS = 'FILTERS',
  SORTING = 'SORTING',
}
